import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import NewsCard from '../../components/Cards/NewsCard';
import ReactPaginate from 'react-paginate';
import DatePicker, { registerLocale } from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import tr from 'date-fns/locale/tr';
import { IoNewspaperOutline } from "react-icons/io5";
import { getActiveNews } from '../../api/newsService';

registerLocale('tr', tr);

const DEFAULT_IMAGE = '/assets/images/example-post.jpg';

const News = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(6);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [newsData, setNewsData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchNews();
  }, [currentPage, pageSize, searchTerm]);

  const fetchNews = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await getActiveNews(currentPage, pageSize, searchTerm);
      
      if (response.isSuccess && response.data) {
        setNewsData(response.data.items || []);
        setTotalPages(response.data.pageCount || 0);
        setError(null);
      } else {
        console.error('Failed to fetch news:', response);
        setError('Haberler yüklenirken bir hata oluştu');
        setNewsData([]);
        setTotalPages(0);
      }
    } catch (error) {
      console.error('Error fetching news:', error);
      setError('Haberler yüklenirken bir hata oluştu');
      setNewsData([]);
      setTotalPages(0);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1);
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    setCurrentPage(1);
  };

  const handleImageError = (e) => {
    console.log('Image failed to load, using default image');
    e.target.src = DEFAULT_IMAGE;
  };

  return (
    <div className="news-page">
      
      <div className="news-tabs">
        <div className="container">
          <div className="news-tabs-filter">
            <div className="news-tabs-filter-left">
              <div className="news-tabs-filter-left-item">
                <input 
                  type="text" 
                  placeholder="Haberlerde Ara" 
                  value={searchTerm}
                  onChange={handleSearch}
                />
                <i className="pi pi-search"></i>
              </div>
            </div>
            <div className="news-tabs-filter-right">
              <div className="news-tabs-filter-right-item">
                <DatePicker
                  selected={startDate}
                  onChange={handleDateChange}
                  startDate={startDate}
                  endDate={endDate}
                  selectsRange
                  locale="tr"
                  className="form-control"
                  placeholderText="Tarih Aralığı"
                  dateFormat="dd.MM.yyyy"
                  isClearable
                />
                <i className="pi pi-calendar"></i>
              </div>
            </div>
          </div>
          
          <div className="news-tabs-content">
            {loading ? (
              <div className="loading">Yükleniyor...</div>
            ) : error ? (
              <div className="alert alert-warning" role="alert">
                {error}
              </div>
            ) : newsData.length === 0 ? (
              <div className="text-center py-5">
                <p>Haber bulunamadı.</p>
              </div>
            ) : (
              <div className="news-cards">
                {newsData.map((news) => (
                  <Link key={news.guid} to={`/haberler/${news.urlTag}`}>
                    <NewsCard
                      image={news.pictureUrl || DEFAULT_IMAGE}
                      title={news.header}
                      description={news.shortDetail || news.detail}
                      date={new Date(news.newsDate).toLocaleDateString('tr-TR')}
                      onImageError={handleImageError}
                    />
                  </Link>
                ))}
              </div>
            )}
          </div>

          {!loading && !error && newsData.length > 0 && (
            <ReactPaginate
              previousLabel="<"
              nextLabel=">"
              pageCount={totalPages}
              onPageChange={handlePageChange}
              containerClassName="pagination"
              activeClassName="active"
              forcePage={currentPage - 1}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default News;